import { render, staticRenderFns } from "./MentionableCustom.vue?vue&type=template&id=584a7d39"
import script from "./MentionableCustom.vue?vue&type=script&lang=js"
export * from "./MentionableCustom.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports